import React from "react";

export const inputCls = "mt-1 w-full rounded-lg border border-border bg-white px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/30";
export const btnPrimary = "inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground font-semibold px-5 py-2.5 text-sm hover:bg-[hsl(28_90%_38%)] disabled:opacity-60";
export const btnSecondary = "inline-flex items-center justify-center gap-2 rounded-full border border-border bg-white text-stone-700 font-semibold px-5 py-2.5 text-sm hover:bg-muted disabled:opacity-60";

export function Field({ label, children, className = "", hint }) {
  return (
    <label className={`block text-sm ${className}`}>
      <span className="text-stone-600">{label}</span>
      {children}
      {hint && <span className="block mt-1 text-xs text-stone-400">{hint}</span>}
    </label>
  );
}

export function TextInput({ testId, ...props }) {
  return <input data-testid={testId} className={inputCls} {...props} />;
}

export function SelectInput({ testId, options, ...props }) {
  return (
    <select data-testid={testId} className={inputCls} {...props}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}

export function ErrorBox({ message, testId = "form-error" }) {
  if (!message) return null;
  return <div data-testid={testId} className="rounded-lg bg-red-50 border border-red-100 text-red-700 text-sm px-4 py-2.5">{message}</div>;
}

export function Card({ title, subtitle, action, children, className = "", testId }) {
  return (
    <section data-testid={testId} className={`rounded-xl border border-border bg-card p-5 sm:p-6 ${className}`}>
      {(title || action) && (
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            {title && <h2 className="font-serif text-lg font-bold text-stone-900">{title}</h2>}
            {subtitle && <p className="text-sm text-stone-500 mt-0.5">{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

const TONES = {
  ACTIVE: "bg-emerald-50 text-emerald-700 border-emerald-200", APPROVED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  VERIFIED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  PENDING: "bg-amber-50 text-amber-700 border-amber-200", UNDER_REVIEW: "bg-amber-50 text-amber-700 border-amber-200",
  SUBMITTED: "bg-amber-50 text-amber-700 border-amber-200", PENDING_VERIFICATION: "bg-amber-50 text-amber-700 border-amber-200",
  REJECTED: "bg-red-50 text-red-700 border-red-200", BLOCKED: "bg-red-50 text-red-700 border-red-200",
  SUSPENDED: "bg-orange-50 text-orange-700 border-orange-200", INACTIVE: "bg-stone-100 text-stone-600 border-stone-200",
  NOT_SUBMITTED: "bg-stone-100 text-stone-600 border-stone-200",
};

export function StatusBadge({ value, testId }) {
  if (!value) return null;
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold tracking-wide ${TONES[value] || "bg-stone-100 text-stone-600 border-stone-200"}`}>
      {String(value).replace(/_/g, " ")}
    </span>
  );
}

export function fmtDate(v) {
  if (!v) return "—";
  return new Date(v).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
}
